module.exports = __webpack_public_path__ + "static/media/alert.09831de7.svg";